<ng-container
  *ngIf="isDropDown == null || isDropDown == false; else elseTemplate"
>
  <div class="row p-3" [ngClass]="className" *ngIf="paging">
    <div class="col-sm-4 order-sm-1 col-12 p-1 px-2 order-1">
      <!-- <div class="row">
            <div
            class="col-12 justify-content-md-start d-flex justify-content-center align-content-center align-items-center">
            </div>
        </div> -->
      <p class="m-0">
        {{ "ShowPage" | translate }}
        <span>{{ paging.pageNumber | number }}</span>
        {{ "Of" | translate }}
        <span>{{ paging.totalPages | number }}</span>
        &nbsp;|&nbsp;
      </p>
      <p class="m-0">
        {{ "TotalNumber" | translate }}
        <span>
          {{ paging.totalElements | number }}
        </span>
        {{ "Record" | translate }}
      </p>
    </div>
    <div class="col-sm-4 order-sm-2 col-12 p-sm-1 py-1 px-0 order-3">
      <nav aria-label="Page navigation">
        <ul
          *ngIf="paging.empty == false"
          id="table.paging"
          class="pagination pagination-info justify-content-center flex-wrap m-0"
        >
          <li *ngIf="paging.first == false" class="page-item first">
            <button class="page-link" type="button" (click)="changePage(1)">
              <i class="tf-icon bx bx-chevrons-left"></i>
            </button>
          </li>
          <li *ngIf="paging.first == false" class="page-item prev">
            <button
              class="page-link"
              type="button"
              (click)="changePage(paging.pageNumber - 1)"
            >
              <i class="tf-icon bx bx-chevron-left"></i>
            </button>
          </li>
          <li
            *ngIf="paging.first == false && 1 < paging.pagingList[0]"
            class="page-item"
          >
            <button class="page-link" type="button" disabled>..</button>
          </li>

          <li
            *ngFor="let item of paging.pagingList"
            [ngClass]="{ active: item === paging.pageNumber }"
            class="page-item"
          >
            <button class="page-link" type="button" (click)="changePage(item)">
              {{ item }}
            </button>
          </li>
          <li
            *ngIf="
              paging.last == false && paging.totalPages > paging.pagingList[9]
            "
            class="page-item"
          >
            <button class="page-link" type="button" disabled>..</button>
          </li>
          <li *ngIf="paging.last == false" class="page-item next">
            <button
              class="page-link"
              type="button"
              (click)="changePage(paging.pageNumber + 1)"
            >
              <i class="tf-icon bx bx-chevron-right"></i>
            </button>
          </li>
          <li *ngIf="paging.last == false" class="page-item last">
            <button
              class="page-link"
              type="button"
              (click)="changePage(paging.totalPages)"
            >
              <i class="tf-icon bx bx-chevrons-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
    <div class="col-sm-4 order-sm-3 col-12 p-1 col-12 order-2">
      <label style="margin: unset">{{ "NumberOfItems" | translate }}</label>
      <select
        class="form-select mx-2"
        style="width: 28%"
        [(ngModel)]="pagingSize"
        (change)="changePageSize()"
      >
        <option value="1">1</option>
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="30">30</option>
        <option value="40">40</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
    </div>
  </div>
</ng-container>
<ng-template #elseTemplate>
  <nav aria-label="Page navigation" *ngIf="paging">
    <ul
      *ngIf="paging.empty == false"
      id="table.paging"
      class="pagination pagination-info justify-content-center flex-wrap m-0"
    >
      <li *ngIf="paging.first == false" class="page-item prev">
        <button
          class="page-link"
          type="button"
          (click)="changePage(paging.pageNumber - 1)"
        >
          <i class="tf-icon bx bx-chevron-left"></i>
        </button>
      </li>
      <li
        *ngIf="paging.first == false && 1 < paging.pagingList[0]"
        class="page-item"
      >
        <button class="page-link" type="button" disabled>..</button>
      </li>

      <li
        *ngFor="let item of paging.pagingList"
        [ngClass]="{ active: item === paging.pageNumber }"
        class="page-item"
      >
        <button class="page-link" type="button" (click)="changePage(item)">
          {{ item }}
        </button>
      </li>
      <li
        *ngIf="paging.last == false && paging.totalPages > paging.pagingList[2]"
        class="page-item"
      >
        <button class="page-link" type="button" disabled>..</button>
      </li>
      <li *ngIf="paging.last == false" class="page-item next">
        <button
          class="page-link"
          type="button"
          (click)="changePage(paging.pageNumber + 1)"
        >
          <i class="tf-icon bx bx-chevron-right"></i>
        </button>
      </li>
    </ul>
  </nav>
</ng-template>
